import EtablissementT1790 from '@/generated/controls/etablissement/EtablissementT1790.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: EtablissementT1790
})
